
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-preview",
      function () {
        return require("private-next-pages/home-preview.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-preview"])
      });
    }
  